import {
  Button, Modal, Pagination, Space, Table,
} from 'antd';
import moment from 'moment';
import ticketsTableColumns from './ticketsTableColumns';
import translations from '../../../hooks/translation/translations.json';
import { adminRefundTicketsService } from '../../services/ticketServices';
import useTranslation from '../../../hooks/translation/useTranslation';

export default function TicketsTable({ data, fetchData }) {
  const { trans } = useTranslation();
  const handleRefund = async (ticketId) => {
    await adminRefundTicketsService(ticketId);
    await fetchData();
  };

  return (
    <div className="overflow-table">
      <Space size="large" direction="vertical" style={{ width: '100%' }}>
        <Table
          pagination={false}
          dataSource={data?.data?.map((ticket) => ({
            key: ticket?.id,
            id: ticket?.id,
            ride_id: ticket?.ride_id,
            statement_id: ticket?.statement?.statement_id,
            ticket_number: ticket?.ticket_number,
            date_time: moment(ticket?.departure_date).format('YYYY-MM-DD HH:mm'),
            created_at: moment(ticket?.created_at).format('YYYY-MM-DD HH:mm'),
            ticket_start_station: ticket?.ticket_start_station?.name,
            ticket_end_station: ticket?.ticket_end_station?.name,
            ticket_owner: ticket?.passenger || ticket?.customer?.name,
            customer_email: ticket?.customer?.email,
            is_refunded: trans(ticket?.is_refunded ? 'yes' : 'no'),
            refund: !ticket?.is_refunded && (
              <Button
                type="danger"
                onClick={() => {
                  Modal.confirm({
                    title: translations.ka.refund,
                    onOk: () => handleRefund(ticket?.id),
                  });
                }}
              >
                {trans('refund')}
              </Button>
            ),
          }))}
          columns={ticketsTableColumns.map(
            (col) => ({
              ...col,
              title: trans(col.title),
            }),
          )}
        />
        {data && (
        <Pagination
          total={data?.meta?.totalItems}
          pageSize={data?.meta?.itemsPerPage}
          showSizeChanger={false}
          current={data?.meta?.currentPage}
          onChange={(e) => fetchData(e)}
        />
        )}
      </Space>
    </div>
  );
}
